import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const Key: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m250 660h-130v-123.18l152.56-153.55c-16.12-46.65-14.36-96.93 5.16-142.64 20.84-48.78 59.43-86.53 108.66-106.29 49.36-19.81 103.36-19.27 152.05 1.53s86.41 59.44 106.23 108.8c40.79 101.62-8.71 217.49-110.33 258.27-44.59 17.9-93.42 19.07-138.56 3.5l-31.16 31.16h-54.6v61.2h-60v61.2zm-100-30h70v-61.2h60v-61.2h72.17l36.19-36.19 9.19 3.69c40.5 16.25 85.1 16.25 125.59 0 86.27-34.63 128.29-132.99 93.66-219.26-16.83-41.93-48.85-74.74-90.17-92.39s-87.16-18.1-129.09-1.28c-41.79 16.77-74.55 48.82-92.24 90.23s-18.2 87.24-1.42 129.03l3.68 9.16-157.57 158.59v80.81z' />
    <circle cx='510' cy='270' r='30' />
  </IconBase>
));

Key.displayName = 'Key';

export default Key;
